import React from 'react'
import classnames from 'classnames'
import Card, { Props as CardProps } from '../card/Card'

export type ListCardProps = CardProps

function ListCard(props: ListCardProps) {
  const { className, children, ...rest } = props

  return (
    <Card
      stack
      className={classnames('dnb-list__card', className)}
      {...rest}
    >
      {children}
    </Card>
  )
}

ListCard._supportsSpacingProps = true

export default ListCard
